import { useState } from "react";

import { SmallButton } from "../../../../atoms/Buttons/SmallButton";
import { ClearButton } from "../../../../atoms/ClearButton/ClearButton";
import { Position } from "../../../../molecules/Player/SquadBuilderPlayer/Position/Position";
import { PlayerPlaceHolder } from "../../../../molecules/PlayerPlaceHolder/PlayerPlaceHolder";
import { FilterButton } from "../FilterButton/FilterButton";

type Props = {
  role?: string;
  isOverItem?: boolean;
  onClickPlayerRole?: () => void;
  onClickPlayerPlaceHolder?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickFilter?: () => void;
  onClickRemove?: () => void;
  activePlayerRole?: boolean;
  activePlayerPlaceHolder?: boolean;
  formationPosition?: string;
  numberOfFilters?: number;
  onClearFilters?: () => void;
  disablePlayerFilters?: boolean;
  isOnBench?: boolean;
  tabletOrLargerMode?: boolean;
};

export const PitchItem = ({
  role,
  isOverItem,
  onClickPlayerRole,
  onClickPlayerPlaceHolder,
  onClickRemove,
  onClickFilter,
  activePlayerPlaceHolder,
  activePlayerRole,
  formationPosition,
  numberOfFilters,
  onClearFilters,
  disablePlayerFilters,
  tabletOrLargerMode,
}: Props) => {
  const [onHover, setOnHover] = useState(false);
  return (
    <div
      className="relative flex flex-col items-center px-2 touch-device:gap-y-1"
      onMouseEnter={() => tabletOrLargerMode && setOnHover(true)}
      onMouseLeave={() => tabletOrLargerMode && setOnHover(false)}
    >
      <div className="relative flex flex-row items-center gap-x-2 w-fit">
        <PlayerPlaceHolder
          onClick={onClickPlayerPlaceHolder}
          activePlayerPlaceHolder={activePlayerPlaceHolder || isOverItem}
          tabletOrLargerMode={tabletOrLargerMode}
        />
        <>
          {(onHover || numberOfFilters > 0) && !disablePlayerFilters && (
            <div className="absolute -right-9">
              <FilterButton
                onClick={onClickFilter}
                onClear={onClearFilters}
                numberOfFilters={numberOfFilters}
              />
            </div>
          )}
          {onClickRemove && onHover && (
            <div className="absolute z-10 -right-[14px] -top-[12px] scale-110">
              <ClearButton onClick={onClickRemove} />
            </div>
          )}
        </>
      </div>
      {role && (
        <div className="mx-auto whitespace-nowrap -mt-1 mobile:mt-0">
          <SmallButton
            onClick={() => onClickPlayerRole && onClickPlayerRole()}
            disabled={!onClickPlayerRole}
            active={activePlayerRole}
          >
            {role}
          </SmallButton>
        </div>
      )}
      {formationPosition && (
        <div className="absolute bottom-[-12px] desktop:bottom-[-24px] sb-v2-md:bottom-[-24px] z-[-1] flex items-center justify-center inset-x-0">
          <Position tabletOrLargerMode={tabletOrLargerMode}>
            {formationPosition}
          </Position>
        </div>
      )}
    </div>
  );
};
